<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Approved Files</span>
    </div>
  </div>

  <form [formGroup]="fileNameForm" novalidate>
    <div class="component-container">
      <!-- List Section -->
      @if (DealerFotaCreate) {
        <div class="component-header">
          <h6 class="component-title">Add File</h6>
        </div>
        <div class="component-separator"></div>
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="fileName" class="form-label">File Name</label>
              <mat-form-field appearance="outline">
                <mat-label>File Name</mat-label>
                <input
                  matInput
                  id="fileName"
                  type="text"
                  placeholder="File Name"
                  formControlName="fileName"
                  required
                />
                @if (
                  fileNameForm.controls['fileName'].touched &&
                  fileNameForm.controls['fileName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      fileNameForm.controls['fileName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <div class="component-footer">
          <div class="button-group">
            <button
              type="button"
              [disabled]="!fileNameForm.valid"
              (click)="saveFirmwareVersion()"
              class="submit-button"
            >
              Submit <mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">File Name List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="fileNameForm?.get('searchText')?.value"
            matTooltip="File Name"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>File Name</th>
              <th>Uploaded At</th>
              @if (DealerFotaDelete) {
                <th>Action</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (
              item of allFiles
                | paginate
                  : {
                      id: 'batchPaginate',
                      itemsPerPage: pagesize,
                      currentPage: page,
                      totalItems: totalLength,
                    };
              track item;
              let i = $index
            ) {
              <tr>
                <td>{{ i + 1 + (page - 1) * pagesize }}</td>
                <td>{{ item.fileName }}</td>
                <td>{{ item.createdAt }}</td>
                <td>
                  <div class="action-buttons">
                    @if (DealerFotaDelete) {
                      <button
                        type="button"
                        class="primary-button delete-button"
                        (click)="delete(item._id)"
                      >
                        <mat-icon class="btn-icon">delete</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
          @if (totalLength === 0) {
            <tbody>
              <tr>
                <td colspan="10">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          @if (totalLength !== 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="pagesize"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    </div>
  </form>
</div>
